export enum Controller {
  AdminBallTypes = 'admin-ball-types',
  AdminErrorTypes = 'admin-error-types',
  AdminMachines = 'admin-machines',
  AdminModels = 'admin-models',
  AdminPitchLists = 'admin-pitch-lists',
  AdminTeams = 'admin-teams',
  AdminUsers = 'admin-users',
  AppLogs = 'app-logs',
  Auth = 'auth',
  CustomerV1 = 'customer/v1',
  Data = 'data',
  DataV3 = 'data/v3',
  Hitters = 'hitters',
  Hub = 'hub',
  MachineConfigBackups = 'machine-config-backups',
  MachineImages = 'machine-images',
  MachineLogFiles = 'machine-log-files',
  Machines = 'machines',
  Main = 'main',
  MlbStats = 'mlb-stats',
  Pitches = 'pitches',
  PitchLists = 'pitch-lists',
  Python = 'python',
  ServerErrors = 'server-errors',
  ServerLogs = 'server-logs',
  Sessions = 'sessions',
  Shot = 'shot',
  SlackBot = 'slack-bot',
  State = 'state',
  Streaming = 'streaming',
  Terms = 'terms',
  Trackman = 'trackman',
  UserModels = 'user-models',
  Videos = 'videos',
}
